import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner, SpinnerSize } from "@fluentui/react";
const SpinnerOverlay = ({ label = "Loading...", isBlocking = true, backgroundColor = "rgba(255, 255, 255, 0.6)", }) => {
    const style = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor,
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents: isBlocking ? "auto" : "none",
    };
    return (_jsx("div", { style: style, children: _jsx(Spinner, { label: label, size: SpinnerSize.large }) }));
};
export default SpinnerOverlay;
